import { Injectable } from '@angular/core';
import { Response, ResponseContentType, RequestOptions, URLSearchParams } from '@angular/http';

import { Order, OrderLine } from '../../../../../../data/models/transaction/op/outbound/order';
import { AuthHttp, QueryEncoderHelper } from '../../../../../common';
import { AppSettings } from '../../../../../settings';
import { InterfaceTemplate } from 'app/data/models/transaction/interface/interface-template';

@Injectable()
export class OnlineOrderService {
    constructor(private http: AuthHttp) { }

    getAuthOwnerCustomerReprecentatives(groupId: string, isIncludeAll?: boolean) {
        let params: URLSearchParams = new URLSearchParams();
        params.set('groupId', groupId);
        params.set('isIncludeAll', String(isIncludeAll));

        let options: RequestOptions = new RequestOptions({ search: params });
        return this.http.get(AppSettings.apiEndpoint + 'OnlineShipmentOrder/GetAuthOwnerCustomerReprecentatives', options)
            .map((response: Response) => response.json());
    }

    getAuthOwnerCustomerReprecentativeByOwner(ownerCode: string, groupId: string) {
        let params: URLSearchParams = new URLSearchParams();
        params.set('ownerCode', ownerCode);
        params.set('groupId', groupId);

        let options: RequestOptions = new RequestOptions({ search: params });
        return this.http.get(AppSettings.apiEndpoint + 'OnlineShipmentOrder/GetAuthOwnerCustomerReprecentativeByOwner', options)
            .map((response: Response) => response.json());
    }

    // Online shipment order

    getOnlineShipmentOrder(ownerCode: string, onlineOrderNo: string) {
        let params: URLSearchParams = new URLSearchParams();
        params.set("ownerCode", ownerCode);
        params.set("onlineOrderNo", onlineOrderNo);

        let options: RequestOptions = new RequestOptions({ search: params });
        return this.http.get(AppSettings.apiEndpoint + "OnlineShipmentOrder/GetOnlineShipmentOrder", options)
            .map((response: Response) => response.json());
    }

    getShipmentOrderByOnlineOrderNo(ownerCode: string, onlineOrderNo: string) {
        let params: URLSearchParams = new URLSearchParams();
        params.set("ownerCode", ownerCode);
        params.set("onlineOrderNo", onlineOrderNo);

        let options: RequestOptions = new RequestOptions({ search: params });
        return this.http.get(AppSettings.apiEndpoint + "OnlineShipmentOrder/GetShipmentOrderByOnlineOrderNo", options)
            .map((response: Response) => response.json());
    }

    getOnlineShipmentOrdersWithStatus(searchParams: any, $event: any) {
        let params: URLSearchParams = new URLSearchParams();
        // let params: URLSearchParams = new URLSearchParams('', new QueryEncoderHelper());
        // params.set('OwnerCode', searchParams.OwnerCode);
        // params.set('OnlineOrderNo', searchParams.OnlineOrderNo);
        // params.set('OnlineOrderRef', searchParams.OnlineOrderRef);
        // params.set('DeliveryAddress', searchParams.DeliveryAddress);
        // params.set('FromDeliveryDate', searchParams.FromDeliveryDate && searchParams.FromDeliveryDate.toISOString());
        // params.set('ToDeliveryDate', searchParams.ToDeliveryDate && searchParams.ToDeliveryDate.toUTCString());
        // // params.set('ToDeliveryDate', (new Date()).toUTCString());
        // params.set('StatusCode', searchParams.StatusCode);
        // params.set('ShipmentOrderStatus', searchParams.ShipmentOrderStatus);
        // params.set('GroupId', searchParams.GroupId);

        for (let key in searchParams) {
            let value = undefined;

            if (searchParams[key] && searchParams[key] instanceof Date) {
                value = searchParams[key].toUTCString();
            } else {
                value = searchParams[key];
            }

            params.set(key, value);
        }

        // alert(JSON.stringify((new Date()).toUTCString()));
        // alert(JSON.stringify(params.toString()));

        let options: RequestOptions = new RequestOptions({ search: params });
        return this.http.post(AppSettings.apiEndpoint + 'OnlineShipmentOrder/GetOnlineShipmentOrdersWithStatus', $event, options)
            .map((response: Response) => response.json());
    }

    saveOnlineShipmentOrder(order: Order) {
        return this.http.post(AppSettings.apiEndpoint + "OnlineShipmentOrder/SaveOnlineShipmentOrder", order)
            .map((response: Response) => response.json());
    }

    generateShipmentOrder(order: Order) {
        return this.http.post(AppSettings.apiEndpoint + "OnlineShipmentOrder/GenerateShipmentOrder", order)
            .map((response: Response) => response.json());
    }

    deleteShipmentOrder(order: Order) {
        let params: URLSearchParams = new URLSearchParams();
        // let params: URLSearchParams = new URLSearchParams('', new QueryEncoderHelper());
        params.set('OwnerCode', order.OwnerCode);
        params.set('OnlineOrderNo', order.OnlineOrderNo);

        let options: RequestOptions = new RequestOptions({ search: params });
        return this.http.delete(AppSettings.apiEndpoint + "OnlineShipmentOrder/DeleteShipmentOrder", options)
            .map((response: Response) => response.json());
    }

    uploadOrderLine(InterfaceTemplate: InterfaceTemplate) {
        return this.http.post(AppSettings.apiEndpoint + "OnlineShipmentOrder/UploadOrderLine", InterfaceTemplate)
            .map((response: Response) => response.json());
    }
}



// WEBPACK FOOTER //
// ./src/app/infrastructure/services/transaction/op/outbound/order/online-order.service.ts